// theme.ts
import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  components: {
    MuiAutocomplete: {
      styleOverrides: {
        popper: {
          "& .MuiAutocomplete-listbox": {
            fontSize: "10px",
            fontWeight: "bold",
            color: "#000000",
            lineHeight: 1,
          },
          "& .MuiAutocomplete-option": {
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: "100%", // ensures it respects container width
          },
        },
      },
    },
  },
});

export default theme;
